import { useContext } from "react";
import Context from "./context";

const useGlobalState = () => {
  const { globalState, globalDispatch } = useContext(Context);
  return { globalState, globalDispatch };
};

export default useGlobalState;
